import axios from "axios";

export const isFormHost = () => /^(hi|form|forms)\./.test(window.location.hostname);
const BASE = isFormHost() ? "" : process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: `${BASE}/api`,
  timeout: 20000,
});

api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("ttm_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

const RETRYABLE = [502, 503, 504, 520, 521, 522, 523, 524];
const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const cfg = err.config || {};
    const st = err.response?.status;
    const safe = ["get", "head"].includes((cfg.method || "get").toLowerCase()) || cfg.url === "/auth/login";
    // live server restarting (publish): retry quietly instead of showing Cloudflare's error
    if (safe && (!err.response || RETRYABLE.includes(st)) && (cfg._retry || 0) < 4) {
      cfg._retry = (cfg._retry || 0) + 1;
      await sleep(1500 * cfg._retry);
      return api(cfg);
    }
    if (st === 409 && err.response?.data?.detail?.approval_required) {
      const d = err.response.data.detail;
      window.dispatchEvent(new CustomEvent("approval-required", { detail: { ...d, method: cfg.method, path: cfg.url, body: cfg.data ? JSON.parse(cfg.data) : null } }));
      err.response.data = { detail: `${d.label} needs admin approval. Add a reason to send the request.`, approval_required: true };
    }
    if (RETRYABLE.includes(st) && err.response) err.response.data = { detail: "The server is restarting after an update. Please try again in a minute." };
    if (err.response?.status === 401 && !isFormHost() && !["/login", "/oauth/consent"].includes(window.location.pathname)) {
      localStorage.removeItem("ttm_token");
      window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export default api;
